<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog" v-if="showModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('edit') }} {{ $t('user_info') }}</h5>
                        <button type="button" class="btn-close" @click="closeModal"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="editUser">
                            <div class="form-group">
                                <label for="user-select" class="form-label">{{ $t('name') }}</label>
                                <select id="user-select" class="form-select" v-model="selectedUser">
                                    <option value="" disabled selected>{{ $t('select') }} {{ $t('user') }}</option>
                                    <option v-for="user in data" :key="user.user_id" :value="user">
                                        {{ user.user_name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="email" class="form-label">{{ $t('email') }}</label>
                                <input type="email" class="form-control" id="email" v-model="selectedUser.email"
                                    :disabled="selectedUser == ''">
                            </div>
                            <div class="form-group">
                                <label for="password" class="form-label">{{ $t('create') }} {{
                                    $t('password').toLowerCase() }}</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" id="password"
                                        v-model="selectedUser.password"
                                        :disabled="!selectedUser.password || selectedUser.password === ''"
                                        aria-describedby="passwordHelpBlock">
                                    <button type="button" class="btn btn-secondary" @click="generatePassword"
                                        :disabled="selectedUser == ''">{{
                                            $t('generate_password') }}</button>
                                </div>
                                <div id="passwordHelpBlock" class="form-text">{{ $t('password_help') }}</div>
                            </div>
                            <div class="form-group">
                                <label for="company" class="form-label">{{ $t('company') }}</label>
                                <input type="company" class="form-control" id="company" v-model="selectedUser.company"
                                    :disabled="selectedUser == ''">
                            </div>
                            <div class="form-check">
                                <label for="isAdmin" class="form-check-label">{{ $t('is_admin') }}</label>
                                <input type="checkbox" class="form-check-input" id="isAdmin"
                                    v-model="selectedUser.isadmin" aria-describedby="adminHelpBlock"
                                    :disabled="selectedUser == ''">
                            </div>
                            <div id="adminHelpBlock" class="form-text">{{ $t('admin_help') }}</div>
                            <div v-if="message" :class="alertClass">
                                {{ message }}
                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-primary">{{ $t('apply') }}</button>
                                <button type="button" class="btn btn-secondary" @click="closeModal">{{ $t('cancel')
                                    }}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const { getCookie } = require('@/helpers');
import axios from 'axios';

export default {
    data() {
        return {
            selectedUser: '',
            message: '',
            alertClass: ''
        };
    },
    emits: ['close-modal', 'data-updated'],
    components: {

    },
    watch: {
        // selectedUser: {
        //     handler: function (newVal) {
        //         console.log('Selected user handler:', newVal);
        //     },
        //     deep: true
        // }
    },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        data: {
            type: Array,
            default: () => []
        },
        target: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        async editUser() {
            try {
                await axios.post(`${this.$url}/users`,
                    {
                        ...this.selectedUser,
                        action: 'update'
                    },
                    {
                        headers: {
                            Authorization: 'Bearer ' + getCookie('token'),
                            ContentType: 'application/json'
                        }
                    });

                // Handle successful response
                this.setMessage(this.$t('user_edited'), true);
                this.$emit('data-updated');
                // Close modal after 3 seconds
                setTimeout(() => {
                    this.closeModal();
                }, 3000);
            } catch (error) {
                console.error('Error editing user:', error);
                this.setMessage(this.$t('error') + ': ' + error.message, false);
            }
        },
        async generatePassword() {
            try {
                const response = await axios.get(`${this.$url}/generate-password`, {
                    headers: {
                        Authorization: 'Bearer ' + getCookie('token'),
                        ContentType: 'application/json'
                    }
                });
                this.user.password = response.data;
            } catch (error) {
                console.error('Error generating password:', error);
                this.setMessage(this.$t('error') + ': ' + error.message, false);
            }
        },
        closeModal() {
            this.selectedUser = '';
            this.message = '';
            this.$emit('close-modal');
        },
        setMessage(message, isSuccess) {
            this.message = message;
            this.alertClass = isSuccess ? 'alert alert-success' : 'alert alert-warning';
        }
    }
};
</script>

<style scoped>
.modal {
    display: block;
    /* Ensure modal is displayed */
}
</style>